"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoAspectRatioMode = exports.VideoAspectRatio = void 0;
var video_aspect_ratio_1 = require("./video-aspect-ratio");
Object.defineProperty(exports, "VideoAspectRatio", { enumerable: true, get: function () { return video_aspect_ratio_1.VideoAspectRatio; } });
Object.defineProperty(exports, "VideoAspectRatioMode", { enumerable: true, get: function () { return video_aspect_ratio_1.VideoAspectRatioMode; } });
//# sourceMappingURL=index.js.map